import { TopUpAction } from '../action/topup.action';
import { TopUpState } from '../model/topup.types';


export const initialTopUpState: TopUpState = {
    amount: '',
    error: '',
    isSubmitting: false,
};

export const topUpReducer = (
    state: TopUpState,
    action: TopUpAction
): TopUpState => {
    switch (action.type) {
        case 'SET_AMOUNT':
            return {
                ...state,
                amount: action.payload,
                error: '',
            };
        case 'SET_ERROR':
            return {
                ...state,
                error: action.payload,
                isSubmitting: false,
            };
        case 'CLEAR_ERROR':
            return {
                ...state,
                error: '',
            };
        case 'SUBMIT_START':
            return {
                ...state,
                isSubmitting: true,
            };
        case 'SUBMIT_SUCCESS':
            return initialTopUpState;
        case 'RESET':
            return initialTopUpState;
        default:
            return state;
    }
};